var _path, _path2, _g, _g2, _path3, _path4, _path5, _ellipse, _g3, _ellipse2, _g4, _g5, _path6, _path7, _path8, _path9, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermissionDenied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 162,
    viewBox: "0 0 144 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M143.638 148.891C143.638 155.865 111.496 161.481 71.9148 161.481C32.334 161.481 0.191162 155.865 0.191162 148.891C0.191162 141.917 32.334 136.301 71.9148 136.301C111.496 136.301 143.638 141.917 143.638 148.891Z",
    fill: "url(#paint0_radial_7697_77293)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0633 42.1821C32.6191 39.8485 35.2382 38.4468 38.0428 38.4468H104.559C107.364 38.4468 109.983 39.8485 111.539 42.1821L114.488 46.6057C115.499 48.1227 116.039 49.9051 116.039 51.7283H26.5632C26.5632 49.9051 27.1029 48.1227 28.1142 46.6057L31.0633 42.1821Z",
    fill: "url(#paint1_linear_7697_77293)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7697_77293)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.6894,
    cy: 40.8933,
    rx: 7.33981,
    ry: 1.74757,
    fill: "#5681AB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_7697_77293)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.9128,
    cy: 40.8933,
    rx: 7.33981,
    ry: 1.74757,
    fill: "#5681AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7697_77293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 0,
    width: 67,
    height: 43
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.342 42.0684C102.058 42.9903 97.1652 42.9903 94.1174 42.2122V30.5775C94.1174 19.5137 85.1138 10.4338 73.9738 10.4338H68.7089C57.6452 10.4338 48.5653 19.4374 48.5653 30.5775V42.2913C46.1361 42.9903 41.2429 42.9903 38.1882 42.0479V30.5775C38.1882 13.7911 51.8463 0.133057 68.6326 0.133057H73.8975C90.6838 0.133057 104.342 13.7911 104.342 30.5775V42.0684Z",
    fill: "#3B496E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.342 42.0684C102.058 42.9903 97.1652 42.9903 94.1174 42.2122V30.5775C94.1174 19.5137 85.1138 10.4338 73.9738 10.4338H68.7089C57.6452 10.4338 48.5653 19.4374 48.5653 30.5775V42.2913C46.1361 42.9903 41.2429 42.9903 38.1882 42.0479V30.5775C38.1882 13.7911 51.8463 0.133057 68.6326 0.133057H73.8975C90.6838 0.133057 104.342 13.7911 104.342 30.5775V42.0684Z",
    fill: "url(#paint2_linear_7697_77293)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7697_77293)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.6 41.7591H94.376V30.4444C94.376 19.3806 85.3724 10.3007 74.2323 10.3007H68.9675C57.9037 10.3007 48.8238 19.3043 48.8238 30.4444V41.7591H38.4468V30.4444C38.4468 13.658 52.1048 0 68.8912 0H74.156C90.9424 0 104.6 13.658 104.6 30.4444V41.7591Z",
    fill: "url(#paint3_radial_7697_77293)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7697_77293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 39,
    width: 16,
    height: 4
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.6894,
    cy: 40.8933,
    rx: 7.33981,
    ry: 1.74757,
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7697_77293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1882 46.7853H48.5653V38.6814H38.1882V46.7853Z",
    fill: "#576894"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7697_77293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 39,
    width: 16,
    height: 4
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.9128,
    cy: 40.8933,
    rx: 7.33981,
    ry: 1.74757,
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7697_77293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1174 46.7853H104.342V38.6814H94.1174V46.7853Z",
    fill: "#576894"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7697_77293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1174 41.9418V30.5775C94.1174 19.5138 85.1138 10.4338 73.9738 10.4338H68.709C57.6452 10.4338 48.5653 19.4375 48.5653 30.5775V41.9418H45.78C45.6157 39.446 45.4176 36.6023 45.1785 33.3736C43.7805 14.4902 57.4385 5.72534 68.6327 5.72534H73.8975C85.0916 5.72534 98.7496 14.4902 97.3516 33.3736C97.1125 36.6023 96.9144 39.446 96.7501 41.9418H94.1174Z",
    fill: "url(#paint4_radial_7697_77293)"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.039 111.936C116.039 116.82 112.071 120.787 107.188 120.787H35.4142C30.5309 120.787 26.5632 116.82 26.5632 111.936V51.4919C26.5632 46.6086 30.5309 42.6409 35.4142 42.6409H107.188C112.071 42.6409 116.039 46.6086 116.039 51.4919V111.936Z",
    fill: "url(#paint5_linear_7697_77293)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.039 111.936C116.039 116.82 112.071 120.787 107.188 120.787H35.4142C30.5309 120.787 26.5632 116.82 26.5632 111.936V51.4919C26.5632 46.6086 30.5309 42.6409 35.4142 42.6409H107.188C112.071 42.6409 116.039 46.6086 116.039 51.4919V111.936Z",
    fill: "url(#paint6_radial_7697_77293)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5632 112.081C26.5632 116.964 30.5129 120.932 35.3741 120.932H107.228C112.089 120.932 116.039 116.964 116.039 112.081H26.5632Z",
    fill: "#EEF7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5632 112.081C26.5632 116.964 30.5129 120.932 35.3741 120.932H107.228C112.089 120.932 116.039 116.964 116.039 112.081H26.5632Z",
    fill: "url(#paint7_linear_7697_77293)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_7697_77293)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4242 81.5C59.4242 74.2497 65.2929 68.3985 72.5 68.3985C75.3283 68.3985 77.9505 69.2996 80.0928 70.8328L61.5932 88.7298C60.223 86.6594 59.4242 84.1749 59.4242 81.5ZM66.3391 93.0585C68.1762 94.0434 70.2743 94.6015 72.5 94.6015C79.7071 94.6015 85.5758 88.7503 85.5758 81.5C85.5758 79.4297 85.0973 77.4735 84.2458 75.7351L66.3391 93.0585ZM72.5 62C61.7159 62 53 70.7449 53 81.5C53 92.2551 61.7159 101 72.5 101C83.2841 101 92 92.2551 92 81.5C92 70.7449 83.2841 62 72.5 62Z",
    fill: "url(#paint8_linear_7697_77293)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7697_77293",
    x: 36.3496,
    y: 39.1458,
    width: 14.6797,
    height: 4.19415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.699029
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.699029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7697_77293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_7697_77293",
    x: 91.573,
    y: 39.1458,
    width: 14.6797,
    height: 4.19415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.699029
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.699029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7697_77293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7697_77293",
    x: 41.5842,
    y: 2.2302,
    width: 59.3616,
    height: 43.2068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74757,
    result: "effect1_foregroundBlur_7697_77293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_7697_77293",
    x: 53,
    y: 61.3,
    width: 39,
    height: 39.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7697_77293"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7697_77293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.8534 148.737) scale(71.747 12.5472)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515067,
    stopColor: "#BDD0E3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746289,
    stopColor: "#B0D0F2",
    stopOpacity: 0.1656
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7697_77293",
    x1: 71.3011,
    y1: 38.4468,
    x2: 71.3011,
    y2: 51.7283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA7BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7697_77293",
    x1: 74.2027,
    y1: -45.648,
    x2: 74.2027,
    y2: 26.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B496E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7697_77293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.5597 34.4689) rotate(-90) scale(34.602 51.4663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397859,
    stopColor: "#46557E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872917,
    stopColor: "#6F82B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_7697_77293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2651 32.1554) rotate(-90) scale(26.5631 25.9002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.843094,
    stopColor: "#8698C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7697_77293",
    x1: 30.0584,
    y1: 45.6417,
    x2: 71.3011,
    y2: 110.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537495,
    stopColor: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807978,
    stopColor: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_7697_77293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.3011 78.4961) rotate(90) scale(50.3301 66.4054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480806,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992174,
    stopColor: "#E7EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7697_77293",
    x1: 71.223,
    y1: 120.932,
    x2: 71.223,
    y2: 111.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABBCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C8DCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42338,
    stopColor: "#E1EEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7697_77293",
    x1: 48.1412,
    y1: 85.0654,
    x2: 98.9691,
    y2: 81.2293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C2CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionDenied);
export default __webpack_public_path__ + "static/media/permission-denied.0ad57e4dbfca2afeac8a225dffe68153.svg";
export { ForwardRef as ReactComponent };